import Icon from './Icon.jsx';
import s from './Select.module.css';
import fieldCss from './Input.module.css';

export default function Select({ label, options = [], value, onChange, id, className = '', ...rest }) {
  const inputId = id || (label ? `sel-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  return (
    <label className={fieldCss.field} htmlFor={inputId}>
      {label && <span className={fieldCss.label}>{label}</span>}
      <span className={s.wrap}>
        <select
          id={inputId}
          value={value}
          onChange={onChange}
          className={`${s.select} ${className}`.trim()}
          {...rest}
        >
          {options.map(opt =>
            typeof opt === 'object'
              ? <option key={opt.value} value={opt.value}>{opt.label}</option>
              : <option key={opt} value={opt}>{opt}</option>
          )}
        </select>
        <span className={s.chevron}><Icon name="chevron-down" size="sm" /></span>
      </span>
    </label>
  );
}
